import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const Total = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <div className="d-flex flex-column flex-grow-1" style={{ gap: '10px' }}>
            <Card
                title="Total de Permanência"
                value={number.formatToBRNumber(
                    chartData?.counterServices.reduce(
                        (acc, curr) => acc + Number(curr.total_permanences),
                        0
                    ) || 0
                )}
            />
            <Card
                title="Total de Acomodação"
                value={number.formatToBRNumber(
                    chartData?.counterServices.reduce(
                        (acc, curr) => acc + Number(curr.total_acommodations),
                        0
                    ) || 0
                )}
            />
        </div>
    );
};
